import { Typography } from '@material-ui/core'
import { styled, withStyles } from '@material-ui/core/styles'

import ImageContainer from 'artkive/components/ImageContainer'
import theme from 'artkive/utils/theme'

import { MOBILE_IMAGE_RATIO } from './Keepsakes.constants'
import KeepsakeSection from './KeepsakeSection'

export const SMALL_IMAGE_SIZE = 200

export const Section = withStyles(({ breakpoints }) => ({
  root: {
    backgroundColor: theme.colors.white.dark,
  },
  titleWrap: {
    [breakpoints.up('md')]: {
      marginBottom: 48,
    },
  },
}))(KeepsakeSection)

export const Subtitle = styled(Typography)(({ theme: { breakpoints } }) => ({
  maxWidth: 540,
  margin: '16px auto 0',
  textAlign: 'center',
  [breakpoints.down('sm')]: {
    color: theme.colors.grey[700],
    fontWeight: 500,
  },
}))

export const Card = styled('div')({
  backgroundColor: theme.colors.white.main,
  borderRadius: 8,
  boxShadow: theme.shadows[7],
  overflow: 'hidden',
})

export const LargeImage = styled(ImageContainer)({
  overflow: 'hidden',
})

export const LargeText = styled('div')(({ theme: { breakpoints } }) => ({
  padding: '28px 40px 40px',
  [breakpoints.down('sm')]: {
    padding: '24px 16px',
  },
}))

export const BodyWrapper = styled('div')({
  marginTop: 16,
})

export const Column = styled('div')(({ theme: { breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 40,
  [breakpoints.down('sm')]: {
    gap: 24,
  },
}))

export const SmallCard = styled(Card)(({ theme: { breakpoints } }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 28,
  padding: 40,
  [breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 0,
    padding: 0,
  },
}))

export const SmallImage = styled('img')(({ theme: { breakpoints } }) => ({
  width: SMALL_IMAGE_SIZE,
  height: SMALL_IMAGE_SIZE,
  objectFit: 'cover',
  flexShrink: 0,
  [breakpoints.down('sm')]: {
    width: '100%',
    height: 'auto',
    aspectRatio: `${MOBILE_IMAGE_RATIO}`,
  },
}))

export const SmallText = styled('div')(({ theme: { breakpoints } }) => ({
  [breakpoints.down('sm')]: {
    padding: '24px 16px',
  },
}))

export const CtaRow = styled('div')(({ theme: { breakpoints } }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 48,
  [breakpoints.down('sm')]: {
    marginTop: 32,
  },
}))
